<template>
  <div class="step step--last d-flex flex-column" ref="step-last">
    <p class="step_title">{{ step.title }}</p>

    <div
      v-if="equipmentTypeProp === 'standard'"
      class="ml-auto"
    >
      <div>
        <span>{{ mess["mill_lining_individual_solutions_result_company"] }}:</span>
        <b>&nbsp;{{ companyTitle }}</b>
      </div>

      <div>
        <span>{{ mess["mill_lining_individual_solutions_result_type"] }}:</span>
        <b>&nbsp;{{ typeTitle }}</b>
      </div>

      <div>
        <span>{{ mess["mill_lining_individual_solutions_result_equipment"] }}:</span>
        <b>&nbsp;{{ equipmentTitle }}</b>
      </div>
    </div>

    <div v-if="equipmentTypeProp === 'custom'" class="ml-auto">
      <div>
        <span>{{ mess["mill_lining_individual_solutions_result_type"] }}:</span>
        <b>&nbsp;{{ typeTitle }}</b>
      </div>

      <div>
        <span>{{ mess["mill_lining_individual_solutions_th_diameter"] }}:</span>
        <b>&nbsp;{{ equipmentDiameter }}</b>
      </div>

      <div>
        <span>{{ mess["mill_lining_individual_solutions_th_length"] }}:</span>
        <b>&nbsp;{{ equipmentLength }}</b>
      </div>
    </div>

    <table class="step-element_table step-element_table--last-step mt-4 mb-4">
      <tr>
        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_name"] }}
        </th>

        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_qty"] }}
        </th>

        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_weight"] }}
        </th>

        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_material"] }}
        </th>

        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_price"] }}
        </th>

        <th>
          {{ mess["mill_lining_individual_solutions_result_table_th_price_total"] }}
        </th>
      </tr>

      <tr v-for="(step, stepIndex) in tableSteps" :key="`step-${stepIndex}`">
        <td
          colspan="6"
          class="pa-0"
          style="border: none"
        >
          <table>
            <tr>
              <td
                colspan="6"
                style="text-align: center; font-weight: 500; padding: 8px; font-size: 14px; border-bottom: 2px solid; background: #cdcdcd"
              >
                {{ step.title }}
              </td>
            </tr>

            <tr
              v-for="(stepElement, stepElementIndex) in step.stepElements"
              :key="`stepElementIndex-${stepElementIndex}`"
            >
              <td
                colspan="6"
                class="pa-0"
                style="border: none; border-left: 1px solid; border-right: 1px solid;"
              >
                <span
                  style="font-weight: 500; display: inline-block; padding: 6px 0 6px 4px; font-size: 13px; width: 100%; background: #e6e6e6;"
                >
                  {{ stepElementIndex + 1 }}.
                  {{ stepElement.elementName }}
                </span>

                <table>
                  <tr
                    v-for="(row, rowIndex) in stepElement.rows"
                    :key="`row-${rowIndex}`"
                  >
                    <td style="border-left: none;">
                      {{
                        row.name ||
                          (row.element ? `${row.element} ${rowIndex + 1}` : "")
                      }}
                    </td>

                    <td>{{ row.qty }}</td>

                    <td>{{ row.weight }}</td>

                    <td>{{ row.material || "-" }}</td>

                    <td>{{ (getItemPrice(row) || 0).toFixed(2) }}</td>

                    <td style="border-right: none;">
                      {{ (getRowPrice(row) || 0).toFixed(2) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

<!--    <div class="ml-auto mt-4 mb-4">-->
<!--      <span>{{ mess["mill_lining_individual_solutions_result_price_total"] }}:</span>-->

<!--      <b>&nbsp;{{ totalPrice.toFixed(2) }}</b>-->
<!--    </div>-->
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import scrollToElement from "@/utils/scroll-to-element";

export default {
  name: "StepLast",
  props: {
    companies: {
      type: Array,
      default: () => []
    },
    defaultTypes: {
      type: Array,
      default: () => []
    },
    equipmentTypeProp: {
      type: String,
      default: "standard"
    },
    equipments: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    isFirstStep: {
      type: Boolean,
      default: false
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    materials: {
      type: Array,
      default: () => []
    },
    rerenderKey: {
      type: Number,
      default: Date.now()
    },
    selectedBasis: {
      type: [Number, String],
      required: true
    },
    step: {
      type: Object,
      default: () => ({})
    },
    steps: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    company() {
      return this.steps[1]?.stepElements[0]?.rows[0]?.company;
    },
    companyTitle() {
      return this.companies.find(c => c.id === this.company)?.title;
    },
    equipment() {
      return this.steps[1]?.stepElements[0]?.rows[0]?.equipment;
    },
    equipmentDiameter() {
      return this.steps[1]?.stepElements[1]?.rows[0]?.diameter;
    },
    equipmentLength() {
      return this.steps[1]?.stepElements[1]?.rows[0]?.length;
    },
    equipmentTitle() {
      return this.equipments.find(e => e.id === this.equipment)?.title;
    },
    materialsPrice() {
      return this.materials.reduce((obj, material) => {
        const material_price = material.price.find(
          item => item.id === this.selectedBasis
        );

        obj = {
          ...obj,
          [material.name]: material_price.price
        };

        return obj;
      }, {});
    },
    tableSteps() {
      return this.steps.slice(1, this.steps.length - 1);
    },
    totalPrice() {
      return (
        this.tableSteps.reduce((acc, step) => {
          acc = acc + this.getStepPrice(step);
          return acc;
        }, 0) || 0
      );
    },
    type() {
      return this.steps[1]?.stepElements[0]?.rows[0]?.type;
    },
    typeTitle() {
      if (this.equipmentTypeProp === "standard")
        return this.types.find(t => t.id === this.type)?.title;
      if (this.equipmentTypeProp === "custom")
        return this.defaultTypes.find(t => t.id === this.type)?.title;
      return "";
    }
  },
  mounted() {
    if (window.pageYOffset > 400) {
      scrollToElement(this.$refs["step-last"], 400);
    }
  },
  methods: {
    cloneDeep,
    getItemPrice(row) {
      const weight = row.weight || 0;
      return weight * this.materialsPrice[row.material];
    },
    getRowPrice(row) {
      const qty = row.qty || 0;
      return qty * this.getItemPrice(row);
    },
    getStepElementPrice(stepElement) {
      return stepElement.rows?.reduce((acc, r) => {
        acc = acc + this.getRowPrice(r);
        return acc;
      }, 0);
    },
    getStepPrice(step) {
      return step.stepElements?.reduce((acc, sE) => {
        acc = acc + this.getStepElementPrice(sE);
        return acc;
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../Step/Step.scss";
</style>
